import { render, staticRenderFns } from "./gwzNav.vue?vue&type=template&id=7073a11f&scoped=true"
import script from "./gwzNav.vue?vue&type=script&lang=js"
export * from "./gwzNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7073a11f",
  null
  
)

export default component.exports